export enum OrderStatusEnum {
  // Accept = 1,
  Decline = 2,
  ChinaOrderPlaced = 3,
  BodyPlan = 4,
  ShipmentDetails = 5,
  Delivered = 6,
  ALL = 7,
  IN_ORDER = 1,
  Orders= 1,
  Overdue = 8
}

export enum OrderTab {
  Orders = 'Orders',
  Accept = 'Approved',
  Decline = 'Decline',
  ChinaOrderPlaced = 'China Orders',
  BodyPlan = 'Body Plan',
  ShipmentDetails = 'Shipment Details',
  Delivered = 'Delivered',
  IN_ORDER = 'In Order',
  Overdue = "Overdue",
  ALL = "All Orders",
}
export enum OrderStatusKey {
  Opened = 'opened',
  Approved = 'approved',
  Declined = 'declined',
  ChinaOrdered = 'china_ordered',
  BodyPlan = 'body_plan',
  ShipmentDetails = 'shipment_details',
  Delivered = 'delivered',
  Overdue = 'overdue',
  ALL="filter_total"
}
export const ORDER_STATUS_TABS = [
  { id: OrderStatusEnum.ALL, label: OrderTab.ALL, countKey: OrderStatusKey.ALL, iconClass: "th th-outline-document-text", showTab: [4], isStatusCountDisplay: false },
  { id: OrderStatusEnum.Orders, label: OrderTab.Orders, countKey: OrderStatusKey.Opened, iconClass: "th th-outline-document-text", showTab: [4, 5], isStatusCountDisplay: true },
  // { id: OrderStatusEnum.Accept, label: OrderTab.Accept, countKey: OrderStatusKey.Approved, iconClass: "th th-outline-tick-circle", showTab: [4, 5], isStatusCountDisplay: true },
  { id: OrderStatusEnum.Overdue, label: OrderTab.Overdue, countKey: OrderStatusKey.Overdue, iconClass: "th th-outline-clock", showTab: [4, 5], isStatusCountDisplay: true },
  { id: OrderStatusEnum.ChinaOrderPlaced, label: OrderTab.ChinaOrderPlaced, countKey: OrderStatusKey.ChinaOrdered, iconClass: "th th-outline-ship", showTab: [4, 5], isStatusCountDisplay: true },
  { id: OrderStatusEnum.BodyPlan, label: OrderTab.BodyPlan, countKey: OrderStatusKey.BodyPlan, iconClass: "th th-outline-box", showTab: [4, 5], isStatusCountDisplay: true },
  { id: OrderStatusEnum.ShipmentDetails, label: OrderTab.ShipmentDetails, countKey: OrderStatusKey.ShipmentDetails, iconClass: "th th-outline-truck", showTab: [4, 5], isStatusCountDisplay: true },
  { id: OrderStatusEnum.Delivered, label: OrderTab.Delivered, countKey: OrderStatusKey.Delivered, iconClass: "th th-outline-truck", showTab: [4], isStatusCountDisplay: true },
  { id: OrderStatusEnum.Decline, label: OrderTab.Decline, countKey: OrderStatusKey.Declined, iconClass: "th th-outline-close-circle", showTab: [4], isStatusCountDisplay: true },
  { id: "settings", label: 'Settings', countKey: "", iconClass: "th th-outline-user-add",showTab: [4], isStatusCountDisplay: false }
];

export enum TERMS_LANGUAGE {
  English = 'English',
  Gujarati = 'Gujarati'
}
export const TERMS_LANGUAGE_OPTIONS = [
  { value: TERMS_LANGUAGE.English, label: 'English' },
  { value: TERMS_LANGUAGE.Gujarati, label: 'Gujarati' }
];
